import Vue from "vue";
import App from "./App.vue";

import store from "@/stores";
import router from "./router";

import Ajax from "@/utils/DuduAjax";

import "@/router/config/permission";
import "@/router/config/project";

import "./styles/index.scss";

import initFonts from "./configs/FontConfigs";
import initComps from "./configs/ComponentConfigs";

import Filters from "./filters";

initFonts();
initComps();

Vue.config.productionTip = false;

Vue.prototype.$http = Ajax;

Vue.use(Filters);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
